export const COMPACT_PERFORMANCE_LEVEL_CARD_SIZE_PX = 64;
const PERFORMANCE_LEVEL_CARD_GAP_PX = 12;

export const getToggledPerformanceLevelId = (
  currentValue: number | null,
  selectedPerformanceLevelId: number,
): number | null => {
  return currentValue === selectedPerformanceLevelId ? null : selectedPerformanceLevelId;
};

export const getCompactPerformanceLevelGroupWidth = (cardCount: number): number => {
  const safeCardCount = Math.max(0, cardCount);
  const gapCount = Math.max(safeCardCount - 1, 0);
  return safeCardCount * COMPACT_PERFORMANCE_LEVEL_CARD_SIZE_PX + gapCount * PERFORMANCE_LEVEL_CARD_GAP_PX;
};
